import { DiaSemanaOrdem } from "../../core/enum/DiaSemana";
import { IMarketplace } from "../interfaces/IMarketplace";

/**
 * Horários do cardápio em uma linha por dia. Mesmo formato usado pelo
 * ms-marketplaces ao montar o aviso de loja fechada, para o que o usuário vê
 * aqui ser o que o cliente recebe lá.
 */
export const formatarHorarioFuncionamento = (marketplaceCardapio?: IMarketplace): string => {
    const horarios = [...(marketplaceCardapio?.configuracao?.horarios ?? [])]
        .sort((a, b) => DiaSemanaOrdem[a.diaSemana] - DiaSemanaOrdem[b.diaSemana]);

    if (!horarios.length) {
        return "Horários não informados";
    }

    return horarios
        .map(dia => {
            const faixas = (dia.horarios ?? [])
                .map(horario => `${horario.inicio} às ${horario.fim}`)
                .join(", ");

            return `${dia.diaSemana}: ${faixas || "Fechado"}`;
        })
        .join("\n");
};

/** Aviso padrão de loja fechada — espelha o texto montado no ms-marketplaces. */
export const montarMensagemLojaFechadaPadrao = (marketplaceCardapio?: IMarketplace): string => {
    const mensagemDoStatus = marketplaceCardapio?.configuracao?.status?.mensagem?.trim();

    return [
        "Olá! No momento estamos fechados 😴",
        mensagemDoStatus,
        `Nosso horário de funcionamento:\n${formatarHorarioFuncionamento(marketplaceCardapio)}`,
        "Assim que abrirmos, é só chamar a gente por aqui que teremos prazer em atender você! 😊",
    ]
        .filter(Boolean)
        .join("\n\n");
};
